import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=cd21e572"
import script from "./wxPay.vue?vue&type=script&lang=js"
export * from "./wxPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports